"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BatchLiquidator__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "host",
                type: "address",
            },
            {
                internalType: "address",
                name: "cfa",
                type: "address",
            },
            {
                internalType: "address",
                name: "superToken",
                type: "address",
            },
            {
                internalType: "address[]",
                name: "senders",
                type: "address[]",
            },
            {
                internalType: "address[]",
                name: "receivers",
                type: "address[]",
            },
        ],
        name: "deleteFlows",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class BatchLiquidator__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.BatchLiquidator__factory = BatchLiquidator__factory;
BatchLiquidator__factory.bytecode = _bytecode;
BatchLiquidator__factory.abi = _abi;
//# sourceMappingURL=BatchLiquidator__factory.js.map